export class TestApiUrls {
    static readonly BASE_URL = `http://localhost:3000`;
    static readonly WIDGET_INFO_API_PATH = `${TestApiUrls.BASE_URL}/view-and-api-management/widgets/`; // WidgetId should be appended
    // static readonly FILTER_INFO_API_PATH = `${TestApiUrls.BASE_URL}/view-and-api-management/filters/`; // FilterId should be appended
    // static readonly LINKING_INFO_API_PATH = `${TestApiUrls.BASE_URL}/view-and-api-management/linking/`; // LinkingId should be appended
}
